import { createContext, useContext, useEffect, useState } from "react";
import { api, setApiToken } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authChecking, setAuthChecking] = useState(true);
  const [user, setUser] = useState(null);
  const [siteName, setSiteName] = useState("Restricted Deals");

  useEffect(() => {
    // /auth/me uses the HttpOnly cookie (withCredentials). On success it also
    // returns a fresh Bearer token so subsequent requests don't need the cookie
    // — this makes auth work in Safari ITP and Chrome incognito.
    api.get("/auth/me").then(
      (r) => {
        setApiToken(r.data.token);
        setUser(r.data);
        setAuthChecking(false);
      },
      () => {
        setAuthChecking(false);
      }
    );
    api.get("/site/meta").then((r) => setSiteName(r.data.site_name)).catch(() => {});
  }, []);

  const login = async (email, password, rememberMe = true) => {
    const { data } = await api.post("/auth/login", { email, password, remember_me: rememberMe });
    if (data.status === "totp_required") {
      return data;
    }
    setApiToken(data.token);
    setUser(data);
    return data;
  };

  const verifyTotp = async (totpToken, code, rememberMe = true) => {
    const { data } = await api.post("/auth/totp/verify", { totp_token: totpToken, code, remember_me: rememberMe });
    setApiToken(data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setApiToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ authChecking, user, setUser, login, logout, verifyTotp, siteName }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
